// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: '/pdv',
  component: () => import('modules/pdv/Index.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'PDV',
            name: 'PDV'
          },
        ]
      },
      name: 'PDV',
      component: () => import('modules/pdv/pdv.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.pdv.retail.dashboard')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'central-de-importacao',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'PDV',
            name: 'PDV'
          },
          {
            text: 'Central de Importação',
            name: 'pdvImportCenter'
          },
        ]
      },
      name: 'pdvImportCenter',
      component: () => import('modules/pdv/pdvImportCenter/pdvImportCenter.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.pdv.retail.import')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'historico-de-importacao',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'PDV',
            name: 'PDV'
          },
          {
            text: 'Histórico de Importação',
            name: 'ImportHistory'
          },
        ]
      },
      name: 'pdvImportHistory',
      component: () => import('modules/pdv/pdvImportHistory/pdvImportHistory.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.pdv.retail.list')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'dashboards',
      meta: {
        breadcrumbs: [
          {
            text: 'NOVO SMART',
            name: 'Dashboard'
          },
          {
            text: 'PDV',
            name: 'PDV'
          },
          {
            text: 'Dashboard',
            name: 'PDVIconListDash'
          },
        ]
      },
      name: 'PDVIconListDash',
      component: () => import('modules/powerbi/PDVIconList.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.pdv.retail.acesso')) {
          next();
        } else {
          next('/');
        }
      }
    },
  ],
  beforeEnter: (to, from, next) => {
    if (hasPermission('web.pdv.retail.dashboard')) {
      next();
    } else {
      next('/');
    }
  }
};
